var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8475_1554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 33.2491C16.6665 27.5357 21.5332 22.9024 27.5332 22.9024C28.4498 18.8357 31.7165 15.5191 36.1065 14.1991C40.4965 12.8757 45.3398 13.7524 48.8098 16.4991C52.2832 19.2391 53.8565 23.4324 52.9398 27.4991H55.2498C57.3887 27.4946 59.4417 28.3398 60.9575 29.8488C62.4734 31.3577 63.3279 33.4069 63.3332 35.5457C63.3279 37.6846 62.4734 39.7338 60.9575 41.2427C59.4417 42.7516 57.3887 43.5968 55.2498 43.5924H27.5332C21.5332 43.5924 16.6665 38.9591 16.6665 33.2491Z",
    stroke: "#BF4036",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 43.5928V53.5928",
    stroke: "#BF4036",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3335 60.2594C33.3335 62.0276 34.0359 63.7232 35.2861 64.9735C36.5364 66.2237 38.2321 66.9261 40.0002 66.9261C41.7683 66.9261 43.464 66.2237 44.7142 64.9735C45.9644 63.7232 46.6668 62.0276 46.6668 60.2594C46.6668 58.4913 45.9644 56.7956 44.7142 55.5454C43.464 54.2952 41.7683 53.5928 40.0002 53.5928C38.2321 53.5928 36.5364 54.2952 35.2861 55.5454C34.0359 56.7956 33.3335 58.4913 33.3335 60.2594Z",
    stroke: "#BF4036",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6665 60.2598H69.9998",
    stroke: "#BF4036",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 60.2598H33.3333",
    stroke: "#BF4036",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8475_1554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0 0.259766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.4c23e831233675b67fa72c52c2fad880.svg";
export { ForwardRef as ReactComponent };